import React from 'react';
import {
  any,
  bool,
  func,
  objectOf,
  oneOf,
} from 'prop-types';
import get from 'lodash/get';
import withWidth from '@material-ui/core/withWidth';
import CloseIcon from '@material-ui/icons/Close';
import Drawer from '@material-ui/core/Drawer';
import '../../../css/notificationsPageV2/components/NotificationActionSheet.scss';
import * as Functions from '../../../services/functions/Functions';
import DateHelper from '../../../services/helpers/DateHelper';
import useIsTablet from '../../../shared/hooks/useIsTablet';
import getResponsiveClassname from '../../../utils/responsiveClassnames';

const NotificationActionSheetComponent = ({
  isOpen,
  setIsOpen,
  width,
  notification,
  translation,
}) => {
  const isMobile = Functions.isMobileV2(width);
  const isDark = Functions.isDarkTheme();
  const isTablet = useIsTablet();

  return (
    <Drawer
      anchor="bottom"
      ModalProps={{
        BackdropProps: {
          style: {
            backdropFilter: 'blur(10px)',
            webkitBackdropFilter: 'blur(10px)',
          },
        },
      }}
      open={isOpen}
      onClose={() => setIsOpen(false)}
      classes={{
        root: 'notificationActionSheet-drawerRoot',
        paperAnchorBottom: getResponsiveClassname(
          'notificationActionSheet-drawerPaperAnchorBottom',
          isMobile,
          isTablet,
        ),
      }}
    >
      <section className={getResponsiveClassname('notificationActionSheet-container', isMobile, isTablet)}>

        <section className="notificationActionSheet-titleHeaderRow">
          <section className={getResponsiveClassname('notificationActionSheet-titleTextContainer', isMobile, isTablet)}>
            <p className={getResponsiveClassname('notificationActionSheet-titleText', isMobile, isTablet)}>
              {get(notification, 'subject', '')}
            </p>
          </section>
          <section className={getResponsiveClassname('notificationActionSheet-closeButtonContainer', isMobile, isTablet)}>
            <CloseIcon
              className="notificationActionSheet-closeIcon"
              onClick={() => setIsOpen(false)}
            />
          </section>
        </section>
        <section className="notificationActionSheet-spacerBeforeTimestamp" />
        {
          notification && Boolean(notification.sentAt)
          && (
            <p className={`notificationActionSheet-timestamp${isDark ? '-dark' : ''}`}>
              {DateHelper.getFormattedNotificationDate(notification, translation)}
            </p>
          )
        }
        <section className="notificationActionSheet-spacerAfterTimestamp" />
        <p className={getResponsiveClassname('notificationActionSheet-messageText', isMobile, isTablet)}>
          {get(notification, 'messageBody', '')}
        </p>
      </section>
    </Drawer>
  );
};

NotificationActionSheetComponent.propTypes = {
  translation: func.isRequired,
  isOpen: bool.isRequired,
  setIsOpen: func.isRequired,
  notification: objectOf(any),
  width: oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired,
};

NotificationActionSheetComponent.defaultProps = {
  notification: null,
};

const NotificationActionSheet = (withWidth()(NotificationActionSheetComponent));

export default NotificationActionSheet;
